export enum ResponseInfoStatusEnum {
  Ok = 'Ok',
  Error = 'Error'
}
